// --- Intercept add.js XHR to inject _selected_skus ---
(function() {
  var _lastSelectedSkus = '';
  // Snapshot of the settled preset selection — what the SumTracker bundle of
  // this product deducts natively. Sent as _preset_skus so the inventory Flow
  // can compute the delta (deduct what was selected, restock what the preset
  // had) without a metafield.
  var _presetBaselineSkus = null;

  window._etSnapshotBaselineSkus = function() {
    if (_presetBaselineSkus === null) {
      _presetBaselineSkus = _lastSelectedSkus;
      console.log('[ET] Preset baseline SKUs snapshotted.\n Selected SKUs:', _presetBaselineSkus);
    }
  };

  window._etUpdateSkus = async function() {
    // console.log(11111)
    if (!window.expivi) return;
    // console.log(2222)
    var attrs = await window.expivi.getProductAttributes();
    _lastSelectedSkus = attrs
      .filter(function(a) {
        return a.type === 'question' && a.visible !== false
          && a.attribute_values && a.attribute_values.length > 0;
      })
      .map(function(a) {
        const sel = a.attribute_values.find(v => v.id === a.selected_value_id);
        if (!sel?.key) return null;
        if (sel.key.startsWith('att-')) return null;
        return sel.key;
      })
      .filter(Boolean)
      .join(',');
  };

  window._etGetSelectedSkus = function() {
    return _lastSelectedSkus;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._etUrl = url;
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    if (this._etUrl && this._etUrl.indexOf('add.js') !== -1 && body) {
      try {
        var data = JSON.parse(body);
        if (!data.properties) data.properties = {};
        // _skus_v2 (NOT _selected_skus): the live Flow matches keys by the
        // substring "_selected_skus", so this name keeps test orders from this
        // theme invisible to it; the new v2 Flow triggers on _skus_v2 only.
        data.properties['_skus_v2'] = _lastSelectedSkus;
        data.properties['_preset_skus'] = _presetBaselineSkus || '';
        body = JSON.stringify(data);
        console.log('[ET] Injected into add.js — _skus_v2:', _lastSelectedSkus, '_preset_skus:', _presetBaselineSkus || '');
      } catch (e) {
        console.log('[ET] add.js body is not JSON, trying FormData');
      }
    }
    return origSend.call(this, body);
  };
})();

document.addEventListener('DOMContentLoaded', function() {
  if (!window.expivi) {
    return;
  }

  var infoPanel = document.querySelector('#expivi-info-panel');
  if (infoPanel) {
    infoPanel.style.display = 'flex';
  }

  // --- Add to cart guard (per Expivi support) ---
  // After the page opens the preset keeps applying for a few seconds; until it
  // settles, getProductAttributes() still returns the catalogue defaults (e.g.
  // Clear downstem instead of Slime). Keep .expivi-add-to-cart disabled until
  // "fully_loaded" has fired and there were no further onChange events for
  // ET_SETTLE_MS, then re-read the SKUs and enable the button. This also
  // prevents the early-click redirect to ?summary_page=1 (404).
  var ET_SETTLE_MS = 800;
  var _etFullyLoaded = false;
  var _etSettled = false;
  var _etSettleTimer = null;

  var _etGuardStyle = document.createElement('style');
  _etGuardStyle.textContent = '.expivi-add-to-cart.expivi-atc-waiting{opacity:.5;cursor:not-allowed;}';
  document.head.appendChild(_etGuardStyle);

  function _etSetAtcDisabled(disabled) {
    document.querySelectorAll('.expivi-add-to-cart').forEach(function(btn) {
      btn.disabled = disabled;
      btn.classList.toggle('expivi-atc-waiting', disabled);
      btn.style.pointerEvents = disabled ? 'none' : '';
    });
  }

  // The configurator renders parts of its DOM after DOMContentLoaded; keep
  // buttons that appear later disabled too, until the preset has settled.
  var _etAtcObserver = new MutationObserver(function() {
    if (!_etSettled) _etSetAtcDisabled(true);
  });

  function _etArmSettleTimer() {
    clearTimeout(_etSettleTimer);
    _etSettleTimer = setTimeout(function() {
      window._etUpdateSkus().then(function() {
        window._etSnapshotBaselineSkus();
        _etSettled = true;
        _etAtcObserver.disconnect();
        _etSetAtcDisabled(false);
        console.log('[ET] Configurator settled, add to cart enabled.\n Selected SKUs:', window._etGetSelectedSkus());
      });
    }, ET_SETTLE_MS);
  }

  _etSetAtcDisabled(true);
  _etAtcObserver.observe(document.body, { childList: true, subtree: true });

  // Never leave the button dead if "fully_loaded" is missed for some reason.
  setTimeout(function() {
    if (!_etSettled && !_etFullyLoaded) {
      console.warn('[ET] fully_loaded not seen after 20s, enabling add to cart anyway');
      _etArmSettleTimer();
    }
  }, 20000);

  // --- Keep _selected_skus updated ---
  window.expivi._events.onReady.subscribe(function() {
    window._etUpdateSkus();
  });

  window.expivi._events.onChange.subscribe(function(e) {
    if (e.name === 'attribute' || e.name === 'buildupdated') {
      window._etUpdateSkus().then(function() {
        console.log('[ET] Selection changed (' + e.name + ')\n Selected SKUs:', window._etGetSelectedSkus());
      });
    }

    if (e.name !== 'frame') {
      if (e.name === 'fully_loaded') _etFullyLoaded = true;
      // Any non-frame event (the preset applying its options) pushes the
      // settle window further out; quiet for ET_SETTLE_MS => enable.
      if (_etFullyLoaded && !_etSettled) _etArmSettleTimer();
    }

    if (e.name === "fully_loaded") {
      var preloader = document.getElementById('product-preloader');
      if (preloader) {
        preloader.style.display = 'none';

        var preloaderText = preloader.querySelector('.preloader-text');
        var lottiePlayer = document.getElementById('lottie-animation-element');

        if (preloaderText) {
          preloaderText.innerHTML = "ONE SEC!<br>WE'RE LOADING...";
        }

        if (lottiePlayer && typeof lottiePlayer.load === 'function') {
          lottiePlayer.load('https://lottie.host/f804d56d-66d8-4b62-a057-5aecf4e81ce4/YTgQW2NMYw.lottie');
        }
      }
    }
  });

  // --- Log attributes with keys for debugging ---
  window.expivi.getProductAttributes().then(function(attrs) {
    var selections = attrs
      .filter(function(a) {
        return a.type === 'question' && a.visible !== false
          && a.attribute_values && a.attribute_values.length > 0;
      })
      .map(function(a) {
        var sel = a.attribute_values.find(function(v) { return v.id === a.selected_value_id; });
        if (!sel || !sel.key || sel.key === '-') return null;
        return { Attribute: a.name, Selected: sel.name, Key: sel.key };
      })
      .filter(Boolean);
    console.table(selections);
  });

  // --- Add to cart preloader ---
  var addToCartButton = document.querySelector('.expivi-add-to-cart');
  if (addToCartButton) {
    addToCartButton.addEventListener('click', function() {
      var preloader = document.getElementById('product-preloader');
      var preloaderText = preloader.querySelector('.preloader-text');
      var lottiePlayer = document.getElementById('lottie-animation-element');

      if (preloader && preloaderText && lottiePlayer) {
        preloaderText.innerHTML = 'ONE SEC!<br>ADDING TO CART...';

        if (typeof lottiePlayer.load === 'function') {
          lottiePlayer.load('https://lottie.host/4b9976d6-e393-4f43-bbfb-4e92ea5ef5a4/MrQM73wRdp.lottie');
        }

        preloader.style.display = 'flex';

        setTimeout(function() {
          if (preloader.style.display === 'flex') {
            preloader.style.display = 'none';
            preloaderText.innerHTML = "ONE SEC!<br>WE'RE LOADING...";
            lottiePlayer.load('https://lottie.host/f804d56d-66d8-4b62-a057-5aecf4e81ce4/YTgQW2NMYw.lottie');
          }
        }, 7000);
      }
    });
  }
});




// window.expivi.getProductAttributes().then(function(attrs) {
//       console.log(22222, attrs)
//       var selections = attrs
//       .filter(function(a) {
//         return a.type === 'question' && a.visible === true
//       && a.attribute_values && a.attribute_values.length > 0;
//     })
//     .map(function(a) {
//       var sel = a.attribute_values.find(function(v) { return v.id === a.selected_value_id; });
//       if (!sel) return null;
//         return { Attribute: a.name, Selected: sel.name, Key: sel.key || '-', ID: sel.id };
//       })
//       .filter(Boolean);
//       console.table(selections);
//     });

//     async function getSelectedSKUs() {
//       var attrs = await window.expivi.getProductAttributes();
//       return attrs
//       .filter(function(a) {
//         return a.type === 'question' && a.visible === true
//         && a.attribute_values && a.attribute_values.length > 0;
//       })
//       .map(function(a) {
//     var sel = a.attribute_values.find(function(v) { return v.id === a.selected_value_id; });
//     if (!sel) return null;
//     return sel.key || String(sel.id);
//     })
//     .filter(Boolean)
//     .join(',');
//     }
// window.xpv_filter_add_to_cart = function(options) {
//   console.log(getSelectedSKUs())
  
//       getSelectedSKUs().then(function(skus) {
//         window.expivi.setProductAttribute()
//       options['_selected_skus'] = skus;
//       });
//       return options;
//   };

// });



